<template>
    <div class="main-box">
      <div v-if="dialogVisible" class="rectangle" ref="rect">
        <div class="equipt-list">
          <div class="equipt-single" @click="handleVipOpenDialog" v-if="dzdqcqyqNum > 0">
            <div class="img-div">
              <img src="../../../assets/img/remind/vip.png"/>
            </div>
            <div class="title-div">权益</div>
            <div class="num" v-if="dzdqcqyqNum > 0">{{dzdqcqyqNum}}</div>
          </div>

<!--          <div class="equipt-single" @click="routerTo('dzdqlqyq')" v-if="dzdqlqyqNum > 0">-->
<!--            <div class="img-div">-->
<!--              <img src="../../../assets/img/remind/vip.png"/>-->
<!--            </div>-->
<!--            <div class="title-div">到期</div>-->
<!--            <div class="num" v-if="dzdqlqyqNum > 0">{{dzdqlqyqNum}}</div>-->
<!--          </div>-->

        </div>

      </div>

      <!-- -->
      <vip-remind ref="vipRemind" v-if="isVipRemindShow"></vip-remind>

    </div>
</template>
<script>
  // import router from "../../../router";

  import VipRemind from './item/vip-remind'

  export default {
    name: 'sysRemind',
    data() {
      return {
        dialogVisible: false,
        dzdqcqyqNum: 1,         //超期仪器数量(电子电器)
        dzdqlqyqNum: 1,         //临期仪器数量(电子电器)
        isVipRemindShow: false
      }
    },
    components: {
      VipRemind
    },
    mounted() {
      document.addEventListener("mousedown", this.handleOutsideClick);
    },
    beforeDestroy() {
      document.removeEventListener("mousedown", this.handleOutsideClick);
    },
    // 初始化
    methods: {
      init(){
        this.dialogVisible = !this.dialogVisible;
        if(this.dialogVisible){
          // return this.request({
          //   method:'post',
          //   url:'/web/service',
          //   params:{
          //     'method': 'tStaticEquipt_getRemindPageInfo',
          //   }
          // }).then((response) =>{          //这里使用了ES6的语法
          //   // 请求成功返回的数据
          //   //如果返回编码不为0，提示失败语
          //   if(response.code !== 0){
          //     this.$message.error(response.msg);
          //     return false;
          //   }
          //
          //   if(!!response.data.dzdqcqyqNum){
          //     this.dzdqcqyqNum = parseInt(response.data.dzdqcqyqNum);
          //   }
          //
          //   if(!!response.data.dzdqlqyqNum){
          //     this.dzdqlqyqNum = parseInt(response.data.dzdqlqyqNum);
          //   }
          //
          // })

        }
      },
      handleVipOpenDialog(){
        this.isVipRemindShow = true;
        this.$nextTick(() => {
          this.$refs.vipRemind.init();
        })
      },
      handleOutsideClick(event) {
        const rect = this.$refs.rect;
        if (rect && !rect.contains(event.target)) {
          this.dialogVisible = false;
        }
      },
      routerTo(type){
        if(type == 'dzdqcqyq'){  //超期仪器(电子电器)
          // router.push({name: 'electronic-base-instrument-instrument' ,params :{type: 'dq'}});
        }else if(type == 'dzdqlqyq'){  //临期仪器(电子电器)
          // router.push({name: 'electronic-base-instrument-instrument' ,params :{type: 'lq'}});
        }
      }
    }
  }
</script>
<style scoped>

.rectangle {
  width: 200px;
  height: 100px;
  background-color: #ffffff;
  position: absolute;
  top: 40px; /* 调整矩形框距离按钮的位置 */
  right: 100px;
  padding: 10px;
  z-index: 10000;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3); /* 添加阴影效果 */
}

.equipt-list{overflow: hidden;}
.equipt-list .equipt-single{
  float: left;
  width: 26px;
  margin: 9px 15px;
  position: relative;
  cursor: pointer;}
.equipt-list .equipt-single:hover{transform: scale(1.03);}
.equipt-list .equipt-single .img-div{width: 100%;
  text-align: center;
  margin-top: 7px;
  height: 15px;
  position: relative;}
.equipt-list .equipt-single .img-div img{
  width: 30px;
  position: absolute;
  bottom: 0px;
  left: 0px;}
.equipt-list .equipt-single .title-div{text-align: center;font-size: 12px;}
.equipt-list .equipt-single .num{
  position: absolute;
  background: red;
  color: #fff;
  border-radius: 10px;
  top: -9px;
  right: -11px;
  padding: 0px 4px;}
</style>




// WEBPACK FOOTER //
// src/views/base/remind/sys-remind.vue